import { CurrencyWrapper } from "@/components/ui/CurrencyWrapper/CurrencyWrapper";
import { Text } from "@/components/ui/Text/Text";
import { Typography } from "@/components/ui/Typography/Typography";
import { Card, CardContent } from "@/components/ui/shadcn/Card/Card";
import { TooltipWrapper } from "@/components/ui/shadcn/Tooltip/TooltipWrapper";
import { cn } from "@/lib/utils/cn";
import { upperCase } from "lodash";
import { CircleHelp } from "lucide-react";

export const PageHighlightCards = ({
  items,
  variant = "accent",
}: {
  items: {
    title: string;
    value: number;
    isCurrency?: boolean;
    showCents?: boolean;
    onHoverText?: React.ReactNode | string;
  }[];
  variant?: "accent" | "summary";
}) => {
  const isSummaryVariant = variant === "summary";

  return (
    <div
      className={cn(
        "w-full",
        isSummaryVariant
          ? cn(
              "grid grid-cols-1 gap-4 sm:grid-cols-2",
              items.length > 2 && "lg:grid-cols-4",
            )
          : "",
      )}
    >
      {isSummaryVariant ? (
        items.map((item) => (
          <div
            key={item.title}
            className="border-border bg-card min-w-0 rounded-lg border p-4"
          >
            <TooltipWrapper message={item.onHoverText ?? ""}>
              <div>
                <Text
                  variant="caption"
                  color="muted"
                  className="mb-2 font-medium tracking-wider uppercase"
                >
                  {upperCase(item.title)}
                </Text>
                <div className="flex items-baseline">
                  <Text variant="title">
                    {item.isCurrency ? (
                      <CurrencyWrapper
                        value={item.value}
                        showCents={item.showCents}
                      />
                    ) : (
                      item.value
                    )}
                  </Text>
                  {item.onHoverText ? (
                    <CircleHelp className="text-muted-foreground ml-2 h-4 w-4 shrink-0" />
                  ) : null}
                </div>
              </div>
            </TooltipWrapper>
          </div>
        ))
      ) : (
        <Card className="w-full">
          <CardContent className="p-0">
            <div className="m-4 flex flex-wrap gap-4">
              {items.map((item) => (
                <Card
                  key={item.title}
                  className="bg-accent/50 min-w-[200px] flex-1 border-none p-6"
                >
                  <CardContent className="p-0">
                    <TooltipWrapper message={item.onHoverText ?? ""}>
                      <div>
                        <Typography
                          variant="subHeading"
                          className="text-primary mb-2"
                        >
                          {upperCase(item.title)}
                        </Typography>
                        <Typography
                          variant="heading"
                          className="text-primary flex items-baseline text-3xl"
                        >
                          {item.isCurrency ? (
                            <CurrencyWrapper
                              value={item.value}
                              showCents={item.showCents}
                            />
                          ) : (
                            item.value
                          )}
                          {item.onHoverText && (
                            <div>
                              <Typography
                                size="xs"
                                className="text-muted-foreground ml-2 text-xs"
                              >
                                <CircleHelp className="h-4 w-4" />
                              </Typography>
                            </div>
                          )}
                        </Typography>
                      </div>
                    </TooltipWrapper>
                  </CardContent>
                </Card>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
